// eslint-disable-next-line
export const PLAYER_DOCK = 'RamblerPlayer.player_dock';
